export default {
  state: {
    isUrgent: false,
    urgencyRate: null,
    urgencyRates: [
      {
        id: '5days',
        label: 'До 5 дней',
        multiplier: {
          textile: 1.3,
          bags: 1.3,
        },
      },
      {
        id: '3days',
        label: 'До 3 дней',
        multiplier: {
          textile: 1.5,
          bags: 2,
        },
      },
      {
        id: '2days',
        label: 'До 2 дней',
        multiplier: {
          textile: 1.7,
          bags: 2,
        },
      },
      {
        id: '1day',
        label: '1 день',
        multiplier: {
          textile: 2.5,
          bags: 2.5,
        },
      },
    ],
  },
  mutations: {
    setUrgency(state, value) {
      state.isUrgent = value
      if (value) {
        state.urgencyRate = state.urgencyRates[0]
      } else {
        state.urgencyRate = null
      }
    },
    setUrgencyRate(state, value) {
      state.urgencyRate = value
    }
  },
}